import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useAsync from '../hooks/useAsync';
import SroServices from '../services/SroServices.js';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import UpdateSro from './Update Model/EditSro.js';

Modal.setAppElement('#root');

function SRO() {
    const [searchTerm, setSearchTerm] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);  // Current page state
    const [itemsPerPage] = useState(50);  // Items per page state

    const { data, error, isLoading, run } = useAsync(SroServices.getAllSro);
    console.log("data", data);

    const handleEditDetails = (sro) => {
        setSelectedEdit(sro);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };

    const handleDelete = (sro) => {
        setSelectedEdit(sro);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Display loading state
    if (isLoading) {
        return (
            <div className="loading-container">
                <div className="loader"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    // Filtered SRO data based on search term
    const filteredSros = data?.data?.filter((sro) =>
        (sro?.sroname?.toLowerCase()?.includes(searchTerm.toLowerCase()) || '') ||
        (sro?.sronameeng?.toLowerCase()?.includes(searchTerm.toLowerCase()) || '') ||
        (sro?.srocode?.toLowerCase()?.includes(searchTerm.toLowerCase()) || '') ||
        (sro?.districtCode?.toLowerCase()?.includes(searchTerm.toLowerCase()) || '')
    ) || [];


    // Calculate total pages
    const totalPages = Math.ceil(filteredSros.length / itemsPerPage);

    // Get the paginated data
    const paginatedThanas = filteredSros.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="right_col" role="main">
            <div className="title-box">
                <h2>SRO (Sub Registrar Office) List <span className="badge bg-orange">{filteredSros.length}</span></h2>
                <div className="container-box-top-header-right">
                    <Link className="round-add-btn" to="/add-sro">
                        <img src="img/plus.svg" alt="Add" />
                    </Link>
                </div>
            </div>
            <div className="container-box px-0">
                <div className="container-box-top-header px-4">
                    <div className="container-box-top-header-left-2">
                        <input type="search" name="search" placeholder="Search" value={searchTerm} onChange={handleSearchChange} />
                        <button className="search-btn">Search</button>
                    </div>
                </div>
                <div className="container-box-inner">
                    <table id="example" className="table table-striped" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>District Name</th>
                                <th>District Code</th>
                                <th>SRO Name</th>
                                <th>SRO Code</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedThanas.map((sro, index) => (
                                <tr key={sro._id}>
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{sro?.district?.name}</td>
                                    <td>{sro?.districtCode}</td>
                                    <td>{sro?.sronameeng}</td>
                                    <td>{sro?.srocode || 'N/A'}</td>
                                    <td>
                                        <div className="action_toggle_outer">
                                            <button
                                                className="action_toggle"
                                                onClick={() => toggleActionMenu(index)}
                                            >
                                                <i className="fa fa-ellipsis-v" />
                                            </button>
                                            {activeIndex === index && (
                                                <div className="action_toggle_content product-edit show d-block">
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                <i className="fa fa-close" />
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button className="edit" onClick={() => handleEditDetails(sro)}>Edit</button>
                                                        </li>
                                                        <li>
                                                            <button className="reject" onClick={() => handleDelete(sro)}>Delete</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
                {/* Pagination Controls */}
                <div className="pagination-controls text-center">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        Previous
                    </button>
                    {[...Array(totalPages)].map((_, pageIndex) => (
                        <button
                            key={pageIndex}
                            className={pageIndex + 1 === currentPage ? 'active' : ''}
                            onClick={() => handlePageChange(pageIndex + 1)}
                        >
                            {pageIndex + 1}
                        </button>
                    ))}
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>
            <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeEditModal}
                contentLabel="Edit Category"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <UpdateSro selectedData={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
            </Modal>
            <Modal
                isOpen={isDeleteModalOpen}
                onRequestClose={closeDeleteModal}
                contentLabel="Delete Confirmation"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <DeleteButton data={selectedEdit} page="sro" closeModal={closeDeleteModal} onSuccess={run} />
            </Modal>
        </div>
    );
}

export default SRO;
